import type { DeepPartial } from '~/types/helper.types';

// https://stackoverflow.com/a/37164538
const isObject = (item): item is Record<string, unknown> => {
  return item && typeof item === 'object' && !Array.isArray(item);
};

const mergeDeep = <T>(target: T, source: DeepPartial<T>): T => {
  const output = Object.assign({}, target);

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }

  return output;
};

export default mergeDeep;
